/// <amd-module name="Artifacts/Sample/redux/Module" />

import { ISampleReducerMap } from "Artifacts/Sample/redux/Contracts";
import { sampleReducer } from "Artifacts/Sample/redux/Reducer";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { VSSPageDataModule } from "VSS/Redux/Modules/VSSPageData";

const _sampleReduxModule: ISagaModule<ISampleReducerMap> = {
  id: "feed-settings",
  reducerMap: {
    simpleState: sampleReducer,
  },
  sagas: [],
};

export const SampleReduxModule = [VSSPageDataModule, _sampleReduxModule];
